import {  callEndpointWithPayload } from "../baseApi";

export const UpdateMenuCategories = async (uuid, idToken, payload) => {
  return await callEndpointWithPayload(`${process.env.REACT_APP_API}/apps/${uuid}/menu_categories`, 'PATCH', idToken, payload)
}